// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as GemExtended } from '../../../assets/icons/extended/entities/gem.svg?react';
import { createIcons } from '../../Icon';
const GemIcon = /* @__PURE__ */ createIcons('Gem', {
    extended: GemExtended
});
GemIcon.supportedTypes = ['extended'];
GemIcon.category = 'entities';
export default GemIcon;
